// extracted by mini-css-extract-plugin
module.exports = {"layout":"quotation_layout__XGv2Y","avatarContainer":"quotation_avatarContainer__JtCEO","quote":"quotation_quote__Nn6eg","landscape":"quotation_landscape__0KJyx"};